import {
    MCFormisFieldText,
    MCFormisFieldAutoComplete,
    //MCFormisFieldCustomHidden
    MCFullRowWrapperComponent,
    MCPanelWrapperComponent,
    MCFormisFieldAttachment,
    MCFormisFieldCheckbox,
    MCFormisFieldTextarea,
    MCFormisFieldAlpha,
    //MCFormisFieldArray,
    //MIFormisFieldArray,
    MCFormisFieldCalendar,
    MCFormisFieldHtmlDisplay,
    MCFormisFieldInfo,
    MCFormisFieldNumeric,
    MCFormisFieldSubTitle,
    MCFormisFieldCustomHidden,
    MCFormisFieldRadio,
} from '@maslul/common-components';
//import { MCFormisFieldCalendar } from '../../app/components/features/request/pages/request-details/formis-field-calendar/formis-field-calendar';
import { MIFormisFieldArray } from '../../app/components/common/formis-field-array/formis-field-array';


export const customFormlyConfig = {
    types: [
        { name: 'date', component: MCFormisFieldCalendar, extends: 'input' },
        { name: 'numeric', component: MCFormisFieldNumeric, extends: 'input' },
        { name: 'alpha', component: MCFormisFieldAlpha, extends: 'input' },
        { name: 'hidden', component: MCFormisFieldCustomHidden },
        { name: 'text', component: MCFormisFieldText, extends: 'input' },
        { name: 'textarea', component: MCFormisFieldTextarea, extends: 'input' },
        { name: 'repeat', component: MIFormisFieldArray },
        { name: 'attachment', component: MCFormisFieldAttachment, extends: 'input' },
        { name: 'autocomplete', component: MCFormisFieldAutoComplete, extends: 'input' },
        { name: 'htmldisplay', component: MCFormisFieldHtmlDisplay },
        { name: 'subtitle', component: MCFormisFieldSubTitle },
        { name: 'info', component: MCFormisFieldInfo },
        { name: 'checkbox', component: MCFormisFieldCheckbox },
        // { name: 'label', component: MCFormisFieldLabel },
        // { name: 'repeatlabel', component: MCFormisFieldLabelArray },
        { name: 'radiobool', component: MCFormisFieldRadio, extends: 'input' },
        { name: 'radio', component: MCFormisFieldRadio, extends: 'input' }
    ],
    wrappers: [
        { name: 'panel', component: MCPanelWrapperComponent },
        { name: 'full-row', component: MCFullRowWrapperComponent }
    ]
};